var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavBtnMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 1C1.5 0.447715 1.94772 0 2.5 0H14.5C15.0523 0 15.5 0.447715 15.5 1C15.5 1.55228 15.0523 2 14.5 2H2.5C1.94772 2 1.5 1.55228 1.5 1ZM0 7C0 6.44772 0.447715 6 1 6H16C16.5523 6 17 6.44772 17 7C17 7.55228 16.5523 8 16 8H1C0.447715 8 0 7.55228 0 7ZM2.5 12C1.94772 12 1.5 12.4477 1.5 13C1.5 13.5523 1.94772 14 2.5 14H14.5C15.0523 14 15.5 13.5523 15.5 13C15.5 12.4477 15.0523 12 14.5 12H2.5Z",
    fill: "#0467AB",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavBtnMobile);
export default __webpack_public_path__ + "static/media/nav_btn-mobile.866c2abafcdcf9bc0a4b5b7687c6f6b4.svg";
export { ForwardRef as ReactComponent };